"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.DEFAULT_CLEANUP_INTERVAL=void 0;var DEFAULT_CLEANUP_INTERVAL=30;exports.DEFAULT_CLEANUP_INTERVAL=30;
//# sourceMappingURL=constants.js.map